import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import App from './app'
import _ from 'lodash'
import * as actions from 'common.actions'
import { getFeatureFlag } from 'layout/actions/featureFlag.action'

const mapStateToProps = state => {
	return {
		loading: state.commonReducer.loading,
		showToastMessage: state.commonReducer.showToastMessage,
		uuidNumber: state.commonReducer.uuidNumber,
		isSignOutTrigger: state.commonReducer.isSignOutTrigger,
		content: _.get(state.i18nReducer.dictionaries[state.i18nReducer.currentLanguage], state.commonReducer.code),
		userInfo: state.commonReducer.userInfo,
		IsAuthorised: state.commonReducer.IsAuthorised,
		isSafariAutoFillInfoVisible: state.commonReducer.isSafariAutoFillInfoVisible,
		...state
	}
}

const mapDispatchToProps = (dispatch) => ({
	setUserInfo: (userInfo) => dispatch(actions.setUserInfo(userInfo)),
	setAutherisation: (flag) => dispatch(actions.setAuthorised(flag)),
	setSafariAutoFillInfo: (flag) => {
		actions.setSafariAutoFillInfoAction(dispatch, flag)
	},
	getFeatureFlagData: (dispatch) => {
		getFeatureFlag(dispatch);
	},
	logout: () => {
		actions.LogOutAction(dispatch)
	}

})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App))
